import React, { memo, useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Sidebar } from 'primereact/sidebar';
import TinyMCEEditorComponent from 'components/HHQComponents/TinyMCE';
import { getMedia, typeTemplate }  from 'components/HHQComponents';
import { UUID4 }  from 'components/HHQComponents';
import { FileObject, TestAttackFileModel } from 'models/test-attack-file.model';
import { AxiosResponse } from "axios";
import { LibraryGetFileModel } from "models/api.model";
import { NewBaseValidateModel } from "models/base-validate.model";
import { LibraryModel } from "models/library.model";
import { BaseResponseListModel, ResponseModelNew } from "models/response.model";
import { TestDetailQuizModel } from "models/test-detail.model";
interface ApiPropTypes {
    getLibrariesFile(data: LibraryGetFileModel): Promise<AxiosResponse<BaseResponseListModel<LibraryModel[]>>>;
    getLibrariesFolder: (data: LibraryGetFileModel) => Promise<AxiosResponse<BaseResponseListModel<LibraryModel[]>>>;
    setLibrary(data: LibraryModel): Promise<AxiosResponse<ResponseModelNew<any>>>;
    deleteLibraryFile(id: string, filePath: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>>;
    deleteLibrary(id: string): Promise<AxiosResponse<ResponseModelNew<NewBaseValidateModel>>>;
    setFile(file: File, folder: string): Promise<AxiosResponse<ResponseModelNew<any>>>;
}
interface PropTypes {
    question: TestDetailQuizModel;
    handleUpdateQuestions: (newValue: TestDetailQuizModel) => void;
    apiService: ApiPropTypes;
    setShowLoading: (isLoading: boolean) => void;
    toast: any;
    baseImageUrl: string;
}

const TieuLuanComponent: React.FC<PropTypes> = ({
  question,
  handleUpdateQuestions,
  apiService,
  toast,
  setShowLoading,
  baseImageUrl
}) => {
  const [config] = useState<TestAttackFileModel>(new TestAttackFileModel());
  const [files, setFiles] = useState<FileObject[]>([]);
  const [selectedFile, setSelectedFile] = useState<FileObject>(new FileObject());
  const [visible, setVisible] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const answerValue = question?.userAnswer?.length ? question.userAnswer[0] : '';

  useEffect(() => {
    if (question.answer && !loaded) {
      setLoaded(true);
      setFiles(JSON.parse(question.answer));
    }
  }, [question]);

  const handleDelete = (file: FileObject) => {
    file.isDelete = true;
    setFiles([...files]);
  };

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const selected = Array.from(event.target.files || []);
      let tooBig = selected.some(f => f.size > 5242880);
      if (tooBig) {
        toast.current?.show({
          severity: 'error',
          summary: 'Thông báo',
          detail: 'Upload tệp có kích thước < 5MB'
        });
        return;
      }

      setShowLoading(true);
      const uploads: Promise<FileObject>[] = selected.map(file => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = e => {
            const type = file.type;
            const newFile: FileObject = {
              id: UUID4(),
              name: file.name,
              size: file.size,
              type: type,
              width: 0,
              height: 0,
              file: file,
              isNew: true,
              isDelete: false,
              url: ''
            };

            if (type.includes('image')) {
              const img = new Image();
              img.onload = () => {
                newFile.width = img.width;
                newFile.height = img.height;
                resolve(newFile);
              };
              img.onerror = reject;
              img.src = e?.target?.result as string;
            } else {
              resolve(newFile);
            }
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      });

      const result = (await Promise.all(uploads)).filter(f => !f.isDelete && f.isNew);
      const newList = [...files, ...result];
      setFiles(newList);
      handleUpdateQuestions({
        ...question,
        attackFiles: newList
      });
      setShowLoading(false);
    } catch (error) {
      setShowLoading(false);
    }
  };

  return (
    <div className="tieu-luan">
      <TinyMCEEditorComponent
        isBasic
        initialValue={answerValue}
        handleEditorChange={val =>
          handleUpdateQuestions({
            ...question,
            userAnswer: [val]
          })
        }
        baseImageUrl={baseImageUrl}
        setShowLoading={setShowLoading}
        toast={toast}
        apiService={apiService}
      />

      <h4>Tệp đính kèm</h4>
      {files.length > 0 ? (
        <DataTable
          value={files.filter(f => !f.isDelete)}
          dataKey="id"
          scrollable
          responsiveLayout="scroll"
        >
          <Column field="type" header="Loại" body={typeTemplate} style={{ width: '100px' }} />
          <Column
            field="name"
            header="Tên"
            body={(rowData: FileObject) => (
              <span
                className="pointer text-blue-400"
                title="Click vào đây để xem nội dung tệp đính kèm"
                onClick={() => {
                  setVisible(true);
                  setSelectedFile(rowData);
                }}
              >
                {rowData.name}{' '}
                {rowData.isNew ? (
                  <i className="text-orange-400 pi pi-sun" title="File mới được thêm, chưa lưu lại" />
                ) : (
                  <i className="pi pi-cloud text-green-400" title="File đã lưu rồi" />
                )}
              </span>
            )}
            style={{ width: 'calc(100% - 350px)' }}
          />
          <Column field="size" header="Kích thước" style={{ width: '150px' }} />
          <Column
            body={(rowData: FileObject) =>
              config.isAccept === 1 ? null : (
                <div className="flex justify-content-end">
                  <div className="flex justify-content-end main-action">
                    <Button
                      icon="pi pi-trash"
                      className="p-button-rounded p-button-text p-button-plain p-button-danger"
                      onClick={() => handleDelete(rowData)}
                    />
                  </div>
                </div>
              )
            }
            exportable={false}
            style={{ width: '100px' }}
          />
        </DataTable>
      ) : (
        <span>Không có file đính kèm</span>
      )}

      {config.evaluateComment && (
        <div>
          Nhận xét giáo viên:
          <div dangerouslySetInnerHTML={{ __html: config.evaluateComment }} />
        </div>
      )}

      {config.isAccept !== 1 && (
        <div className="text-right mt-4">
          <input
            type="file"
            id="fileInput"
            multiple
            style={{ display: 'none' }}
            onChange={handleFileUpload}
          />
          <label
            htmlFor="fileInput"
            className="p-button p-component p-button-sm p-button-label p-c mr-2"
          >
            <i className="pi pi-upload" /> Tải tệp lên
          </label>
        </div>
      )}

      <Sidebar visible={visible} className="w-1000px" position="right" onHide={() => setVisible(false)}>
        <div className="header-title">Nội dung file đính kèm</div>
        <div className="w-100">{getMedia(selectedFile)}</div>
      </Sidebar>
    </div>
  );
};

export default memo(TieuLuanComponent);
